
import {defineComponent} from 'vue'
import {SimulationParameters} from "@/store/SimulationParameters";
import Slider from "vue3-slider";

const controls = [
  {
    key: 'birthRateCommoners',
    step: 0.001,
    min: 0,
    max: 0.1,
    onColor: "#9924f4",
    offColor: "#bc7af4",
  },
  {
    key: 'birthRateElites',
    step: 0.001,
    min: 0,
    max: 0.1,
    onColor: "#2b5bf1",
    offColor: "#a8b9f0",
  },
  {
    // TODO: slider should be logarithmic.
    key: 'inequalityFactor',
    step: 0.25,
    min: 1,
    max: 100,
    onColor: "#decb12",
    offColor: "#f3eec1",
  },
  {
    key: 'depletionPerWorker',
    step: 0.000001,
    min: 0,
    max: 0.0005,
    onColor: "#8e842a",
    offColor: "#b3ad71",
  },
];

export default defineComponent({
  name: 'ParameterControls',
  components: {
    Slider,
  },
  props: {
    initialParameters: {
      required: true,
      type: Object as () => SimulationParameters,
    }
  },
  emits: [ "change" ],
  setup() {
    return {
      controls,
    }
  },
  data() {
    return {
      currentParameters: this.initialParameters,
    };
  },
})
